
<div class="radio-group">
  <div *ngFor="let lang of languages">
    <label>
      <input type="radio" [value]="lang[0]" [(ngModel)]="selectedLanguage" (ngModelChange)="handleLangChange($event)">
      <span><tra [slug]="lang[1]"></tra></span>
    </label>
  </div>
</div>